// extracted by mini-css-extract-plugin
module.exports = {"Container":"SuccessScreen_Container__2JV0K","Countdown":"SuccessScreen_Countdown__1hKMk"};